const Gatotech = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 521.94 521.94">
    <g>
      <path
        d="m170.29 270.91-15.09-31.62-12.23-76.18 31.63-58.22 14.91 50.81 41.34 2.64 26.4-50.57 25.87 59.65 18.37 82.55-8.31 29.2 59.93 158.8 44.3-108.88 53.9 55.34-43.89-7.95-9.21 98.1-87.77-8.22-120.74 9z"
        strokeWidth={35}
        stroke="#010101"
        fill="none"
      />
      <rect
        strokeWidth={10}
        stroke="#010101"
        fill="#010101"
        x={201.02}
        y={201.79}
        width={12.88}
        height={9.04}
        rx={3.46}
      />
      <rect
        strokeWidth={10}
        stroke="#010101"
        fill="#010101"
        x={237.97}
        y={202.75}
        width={12.88}
        height={9.04}
        rx={3.46}
      />
      <path
        strokeWidth={15}
        stroke="#010101"
        d="m191.69 231.52 61.38 9.82"
        transform="translate(4.97 4.97)"
      />
      <rect
        x={4.97}
        y={4.97}
        width={512}
        height={512}
        rx={3.44}
        fill="#c9d8ef"
        strokeOpacity={0}
        strokeWidth={9.94}
        stroke="#010101"
      />
    </g>
    <g id="g843">
      <path
        d="m170.29 270.91-15.09-31.62-12.23-76.18 31.63-58.22 14.91 50.81 41.34 2.64 26.4-50.57 25.87 59.65 18.37 82.55-8.31 29.2 59.93 158.8 44.3-108.88 53.9 55.34-43.89-7.95-9.21 98.1-87.77-8.22-120.74 9z"
        fill="#fff"
        strokeWidth={35}
        stroke="#010101"
      />
      <rect
        strokeWidth={10}
        fill="#010101"
        x={201.02}
        y={201.79}
        width={12.88}
        height={9.04}
        rx={3.46}
      />
      <rect
        strokeWidth={10}
        fill="#010101"
        x={237.97}
        y={202.75}
        width={12.88}
        height={9.04}
        rx={3.46}
      />
      <path
        strokeWidth={15}
        stroke="#010101"
        d="m191.69 231.52 61.38 9.82"
        transform="translate(4.97 4.97)"
      />
    </g>
  </svg>
);

export default Gatotech;
